import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-685807c6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "cases"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "header"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "main"
}, [/*#__PURE__*/_createElementVNode("h3", {
  class: "title"
}, "成功案例")])], -1));
const _hoisted_3 = {
  class: "list"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  class: "container"
};
const _hoisted_7 = {
  class: "title"
};
const _hoisted_8 = {
  class: "desc"
};
import casesData from '@/data/cases';
import { transformMap2List } from '@/utils';
import { useRouter } from 'vue-router';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const list = transformMap2List(casesData);
    const router = useRouter();
    const toDetail = id => {
      router.push(`/cases/${id}`);
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(list), item => {
        return _openBlock(), _createElementBlock("div", {
          class: "list-item",
          onClick: $event => toDetail(item.id),
          key: item.id
        }, [_createElementVNode("img", {
          src: item.listImg,
          alt: ""
        }, null, 8, _hoisted_5), _createElementVNode("div", _hoisted_6, [_createElementVNode("p", _hoisted_7, _toDisplayString(item.title) + "方案", 1), _createElementVNode("p", _hoisted_8, _toDisplayString(item.solution), 1)])], 8, _hoisted_4);
      }), 128))])]);
    };
  }
});